import Vue from 'vue';
import '@/assets/stylesheets/v2/_image-placeholder.scss';
export default Vue.extend({
    props: {
        placeholder: {
            type: String,
            default: 'Add Image',
        },
        size: {
            type: Number,
            default: 16,
        },
    },
    render(createElement) {
        return createElement('div', { class: 'image-placeholder' }, [
            createElement('div', { class: 'content' }, [
                createElement('v-icon', {
                    class: 'icon',
                    props: {
                        dense: true,
                        left: true,
                        size: this.size,
                    },
                }, 'add'),
                createElement('div', {
                    style: {
                        fontSize: `${this.size}px`,
                    },
                }, [this.placeholder]),
            ]),
        ]);
    },
});
